import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * El catálogo de tipos de conexión y workflows del canal POS — pantalla
 * «Tipos y flujos» de la consola de CrediTotal.
 *
 * Pedido textual de Juan (2026-09-20): «qué tipos de solicitudes tengo —que
 * son como tipos de conexión—, y qué workflows tengo, y a qué workflow está
 * conectado cada tipo de solicitud, para cerrar el ciclo».
 *
 * 🔴 SE MIRA, NO SE EDITA: los `tipos` y los `pasos` son de código (nacen en
 * el back, no en una base configurable) y esta vuelta no construye edición de
 * nada. Los `comercios_con_flujo_propio` SÍ son configuración por comercio,
 * pero acá también se listan de sólo lectura.
 *
 * Un solo endpoint, sin filtros ni paginación: la respuesta entera cabe en
 * una pantalla.
 */
@Injectable({ providedIn: 'root' })
export class CatalogoSolicitudesService {
  private api: string;

  constructor(private httpClient: HttpClient) {
    this.api = `${environment.BASE_LA}/api/integracion-pos/admin/catalogo-solicitudes`;
  }

  getCatalogo = async (): Promise<any> =>
    lastValueFrom(this.httpClient.get<any>(this.api));
}
